import React, { memo } from 'react';
import { Handle, NodeProps, NodeToolbar, Position } from 'reactflow';

import { Box, Card, CardActionArea, CardContent, Grid, Tooltip, Typography } from '@mui/material';

import CustomTooltip from '../../common/CustomTooltip';
import usePlaceholderClick from '../hooks/usePlaceholderClick';
import { nodesConfig } from './nodes-config';
import styles from './NodeTypes.module.css';

const PlaceholderNode: React.FC<NodeProps> = ({ id, data }) => {
    const nodesConfigArray = Object.values(nodesConfig);
    const handleClick = usePlaceholderClick(id);

    const handleItemClick = (type: string) => () => {
        handleClick(type);
    };

    return (
        <CustomTooltip title="Click to add a node">
            <div className={`${styles.node} ${styles.placeholder}`}>
                {data.label}

                <NodeToolbar nodeId={id} position={Position.Right}>
                    <Box
                        sx={{
                            // bgcolor: 'background.paper',
                            zIndex: 1300,
                            // border: 1,
                            // borderColor: 'divider',
                            // borderRadius: 2,
                            maxWidth: 600,
                            // maxHeight: 400, // Set a fixed height for the grid container
                            overflowY: 'auto', // Enable vertical scroll
                        }}
                    >
                        <Grid container spacing={1} padding={1}>
                            {nodesConfigArray.slice(1).map((node) => (
                                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ display: 'flex' }} key={node.id}>
                                    <Tooltip title={node.description}>
                                        <Card
                                            sx={{
                                                border: `1px solid ${node.color}`,
                                                backgroundColor: 'background.default',
                                                flex: 1,
                                                boxShadow: 'none',
                                            }}
                                        >
                                            <CardActionArea onClick={handleItemClick(node.id)}>
                                                <CardContent sx={{ padding: 1 }}>
                                                    {/* Icon Component */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                                                        <node.icon htmlColor={node.color} fontSize="small" sx={{ marginRight: 1 }} />
                                                        <Typography variant="body1" color="text.primary">
                                                            {node.name}
                                                        </Typography>
                                                    </Box>
                                                    {/* Text Content */}
                                                    <Box>

                                                        <Typography variant="body2" color="text.secondary" sx={{
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            display: 'inline-block',
                                                            whiteSpace: 'nowrap',
                                                            width: '100%',
                                                        }}>
                                                            {node.description}
                                                        </Typography>
                                                    </Box>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Tooltip>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </NodeToolbar>

                <Handle
                    className={styles.handle}
                    type="target"
                    position={Position.Top}
                    isConnectable={false}
                />
                <Handle
                    className={styles.handle}
                    type="source"
                    position={Position.Bottom}
                    isConnectable={false}
                />
            </div>
        </CustomTooltip>
    );
};

export default memo(PlaceholderNode);
